import { Subtree } from "subtree.js/react";
import { pick } from "trunk.js";
import type { AppDeps } from "../../app-deps";
import { SealedController } from "./sealed-controller";
import { SealedPage } from "./sealed-page";

export function SealedRoute({ deps }: { deps: AppDeps }) {
  return (
    <Subtree
      key="sealed"
      controller={() =>
        new SealedController(pick(deps, "client", "authHandler", "storeRepository", "reviewQueueRepository"))
      }
    >
      <SealedPage />
    </Subtree>
  );
}
